import { Button, ButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { FunctionComponent } from "react";

interface Props {
  isAdvanced: boolean;
  onChange: (isAdvanced: boolean) => void;
}

export const AlmanacModeSwitcher: FunctionComponent<Props> = ({
  isAdvanced,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <ButtonGroup variant="contained" color="secondary">
      <Button
        variant={isAdvanced ? "outlined" : "contained"}
        color="secondary"
        onClick={() => onChange(false)}
      >
        {t("components.almanac.modeBasic")}
      </Button>
      <Button
        variant={isAdvanced ? "contained" : "outlined"}
        color="secondary"
        onClick={() => onChange(true)}
      >
        {t("components.almanac.modeAdvanced")}
      </Button>
    </ButtonGroup>
  );
};
